import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { IMPACT_PERCEPTION } from '../../../../lib/schema.js';
import RadioOptionsField from '../../../RadioOptionsField.jsx';

const options = IMPACT_PERCEPTION.map((type) => ({
  label: capitalize(type),
  value: type,
}));

PerceptionField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

function PerceptionField({ label, name }) {
  return (
    <RadioOptionsField
      id="perception"
      label={label}
      name={name}
      options={options}
    />
  );
}

export default PerceptionField;
